import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '../../axios/axiosInstance';

export const useRegisterUser = () =>
  useMutation(async ({ params }) => {
    const { data } = await axiosInstance.post(`/api/auth/member/register`, { ...params });
    return data;
  });
